import {SupportedLocales} from '#types/locale.js';

export const storageLoggingLanguage = {
  [SupportedLocales.EN]: {
    title: 'Logging to Warehouse',
    description:
      'Write important data from GrowthLoop system to your Warehouse.',
    sourceType: 'Type:',
    audienceSnapshots: {
      label: 'Audience Snapshots',
      description:
        'Stores the current membership of an audience for every Export Run in your warehouse.',
      table: 'audience_snapshots',
    },
    retention: 'Retain',
    storageDataset: 'Storage Dataset',
    loadingDatasets: 'Loading datasets',
    selectDataset: 'Select',
    audienceMetadata: {
      label: 'Audience Metadata',
      description:
        'Stores metadata about your audience including name, description, tags and criteria in your warehouse.',
      table: 'audience_metadata',
    },
    journeyMetadata: {
      label: 'Journey Metadata',
      description:
        'Stores journey details and the full journey graph in your warehouse.',
      table: 'journey_metadata',
    },
    exportRunsMetadata: {
      label: 'Export Runs Metadata',
      description:
        'Store details on all your Export Runs in your warehouse including successful records, rejected records, destination and export id.',
      table: 'export_run_metadata',
    },
    exportRunLogs: {
      label: 'Export Run Logs',
      description:
        'Writes all Export Run logs including errors to your warehouse so you can diagnose data issues for failed records in your audiences.',
      table: 'export_run_logs',
    },
    table: 'Table:',
    save: 'Save',
    confirmTitle: 'Confirm configuration changes',
    confirmDescription:
      'Important. All new audience snapshots will be written to the new dataset selected.',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  [SupportedLocales.ES]: {
    title: 'Registro en el almacén de datos',
    description:
      'Escriba datos importantes del sistema GrowthLoop en su almacén de datos.',
    sourceType: 'Tipo:',
    audienceSnapshots: {
      label: 'Instantáneas de audiencias',
      description:
        'Almacena la membresía actual de una audiencia para cada ejecución de exportación en su almacén de datos.',
      table: 'audience_snapshots',
    },
    retention: 'Conservar',
    storageDataset: 'Conjunto de datos de almacenamiento',
    loadingDatasets: 'Cargando conjuntos de datos',
    selectDataset: 'Seleccionar',
    audienceMetadata: {
      label: 'Metadatos de audiencias',
      description:
        'Almacena metadatos sobre su audiencia, incluidos el nombre, la descripción, las etiquetas y los criterios, en su almacén de datos.',
      table: 'audience_metadata',
    },
    journeyMetadata: {
      label: 'Metadatos de recorridos',
      description:
        'Almacena los detalles del recorrido y el grafo completo en su almacén de datos.',
      table: 'journey_metadata',
    },
    exportRunsMetadata: {
      label: 'Metadatos de ejecuciones de exportación',
      description:
        'Almacena detalles de todas sus ejecuciones de exportación, incluidos los registros correctos, rechazados, el destino y el id de exportación.',
      table: 'export_run_metadata',
    },
    exportRunLogs: {
      label: 'Registros de ejecuciones de exportación',
      description:
        'Escribe todos los registros de ejecuciones de exportación, incluidos los errores, en su almacén de datos para que pueda diagnosticar problemas de datos de los registros fallidos de sus audiencias.',
      table: 'export_run_logs',
    },
    table: 'Tabla:',
    save: 'Guardar',
    confirmTitle: 'Confirmar cambios de configuración',
    confirmDescription:
      'Importante. Todas las nuevas instantáneas de audiencias se escribirán en el nuevo conjunto de datos seleccionado.',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
  },
};
